module.exports = Globalize;


//////////////////
// WEBPACK FOOTER
// external "Globalize"
// module id = 232
// module chunks = 0 1 2